// @flow
export { default } from './QuoteCard';



// WEBPACK FOOTER //
// ./src/components/common/QuoteCard/index.js